import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	max-height: 75dvh;
	height: 100dvh;
	width: 100%;
	overflow: hidden;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		row-gap: 2rem;
	}
`;

export const ConfigContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: var(--padding-2);
	border-left: 1px solid var(--border-color);
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const IframeContainer = styled.div`
	margin-right: 2rem;
	flex: 2;

	> button {
		margin-left: auto;
		margin-bottom: var(--margin-2);
	}

	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: 3rem;

		> button {
			margin-left: unset;
			margin-right: auto;
		}
	}

	@media ${Breakpoints.mobile} {
		margin-right: unset;
	}
`;

export const IframeWrapper = styled.div`
	background-color: var(--content-3);
	border-radius: var(--small-border-radius);
	border: 1px solid var(--border-color);
	max-height: 75dvh;
	height: 100dvh;
	width: 800px;
	display: flex;
	align-items: center;
	justify-content: center;

	@media ${Breakpoints.tablet} {
		width: 50vw;
	}

	@media ${Breakpoints.mobile} {
		width: 75vw;
	}

	> div {
		width: ${(props) => (props.isMobile ? '45rem' : '90rem')};

		@media ${Breakpoints.tablet} {
			width: 50vw;
		}

		@media ${Breakpoints.mobile} {
			width: 75vw;
		}
	}
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: var(--margin-3);
`;

export const IframeHeader = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	background-color: var(--white);
	padding-bottom: var(--padding-1);

	> button {
		&.active {
			background-color: var(--actionButtonHoverColor);
		}
		:first-of-type {
			border-top-right-radius: 0 !important;
			border-bottom-right-radius: 0 !important;
		}
		:last-of-type {
			border-top-left-radius: 0 !important;
			border-bottom-left-radius: 0 !important;
		}

		body[dir='rtl'] & {
			:first-of-type {
				border-top-left-radius: 0 !important;
				border-bottom-left-radius: 0 !important;
			}
			:last-of-type {
				border-top-right-radius: 0 !important;
				border-bottom-right-radius: 0 !important;
			}
		}
	}

	@media ${Breakpoints.tablet} {
		display: none;
	}
`;
